import React from 'react'
import { signInWithGoogle } from './firebase';
import { Navigate } from "react-router-dom";
function Secure() {
  const[login,setlogin] = React.useState("flex p-4 mb-4 bg-red-100 border-t-4 border-red-500");






    if(localStorage.getItem("authenticate")=="true")
{
   console.log("logged in vishu");  
   return <Navigate to="/admin" />
}


else
{


  return (
    <div>


{/* HTML SECTION  */}
<header className="text-gray-600 body-font  ">
  <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center ">
    <a className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
    <img src='hackscript.png' className='logoimg'></img>
      <span className="ml-3 text-xl">HackScript</span>
    </a>
    <nav className=" md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-400	flex flex-wrap items-center text-base justify-center">
    </nav>
    <button type="button"   onClick={signInWithGoogle}  className="text-white bg-gray-900 hover:bg-white hover:text-blue-600 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#4285F4]/55 mr-2 mb-2">
  <svg class="mr-2 -ml-1 w-4 h-4" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>
  Sign in with Google
</button>

    </div>
    </header>
<hr></hr>





<section className="text-gray-600 body-font">
  <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
    <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
      <img
        className="object-cover object-center rounded"
        alt="hero"
        src="react.png"
      />
    </div>
    <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
        Welcome to HackScript 
      </h1>
      <p className="mb-8 leading-relaxed">
        Just Login with Your Existing Google mail , and you are welcome in our community , 100+ of projects contribute to us 
        some of them is barely fundamental as make a payment form and some are mid ranger fetching data from API  , etc Its your turn to contribute and showcase your skills , 
        Dont forget to solve developer weekly .. so you shortlisted in LeaderBoard from various people choose you based on your projet and skills  ,  Happy Hacking Dude 
      </p> 
     
      <button type="button"   onClick={signInWithGoogle}  className="text-white bg-[#4285F4] hover:bg-[#4285F4]/90 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#4285F4]/55 mr-2 mb-2">
  <svg class="mr-2 -ml-1 w-4 h-4" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>
  Sign in with Google
</button>
    
    </div>
  </div>
</section>

<h1 className='head text-gray-700'>Meet HackScript Founders ❤️ </h1>





    </div>
    
  )
}
}

export default Secure